import {NgModule} from '@angular/core';
import {FlagContainerComponent} from './flag-container/flag-container.component';
import {FlagComponent} from './flag-content/flag.component';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SliderModule} from '../slider/slider.module';
import {SharedModule} from '../../shared.module';
import {FlagContainerV2Component} from './flag-container-v2/flag-container-v2.component';
import {FlagContentV2Component} from './flag-content-v2/flag-content-v2.component';
import {CdnPipeModule} from '../../pipes/cdn.pipe';
import { TranslatePipeModule } from '../../pipes/translate.pipe';

@NgModule({
  imports: [CommonModule, SliderModule, ReactiveFormsModule, SharedModule, FormsModule, CdnPipeModule, NgOptimizedImage, TranslatePipeModule],
  declarations: [
    FlagContainerComponent,
    FlagComponent,
    FlagContainerV2Component,
    FlagContentV2Component],
  exports: [FlagContentV2Component,FlagComponent]
})
export class FlagModule {
}
